import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Globe } from 'lucide-react';

const LanguageSwitcher = ({ className = '', variant = 'default' }) => {
  const { language, setLanguage } = useLanguage();

  const isLight = variant === 'light';
  
  return (
    <div 
      className={`flex items-center gap-1.5 ${className}`}
      data-testid="language-switcher"
    >
      <Globe className={`w-4 h-4 ${isLight ? 'text-white/70' : 'text-black/50'}`} />
      <div className={`flex items-center rounded-full p-0.5 ${isLight ? 'bg-white/10' : 'bg-black/5'}`}>
        <button
          onClick={() => setLanguage('de')}
          className={`px-2.5 py-1 text-xs font-semibold rounded-full transition-all duration-200 ${
            language === 'de'
              ? isLight 
                ? 'bg-[#D4AF37] text-[#003366]' 
                : 'bg-[#003366] text-white'
              : isLight 
                ? 'text-white/70 hover:text-white' 
                : 'text-black/50 hover:text-black'
          }`}
          data-testid="lang-switch-de"
          aria-label="Deutsch"
        >
          DE
        </button>
        <button
          onClick={() => setLanguage('en')}
          className={`px-2.5 py-1 text-xs font-semibold rounded-full transition-all duration-200 ${
            language === 'en'
              ? isLight 
                ? 'bg-[#D4AF37] text-[#003366]' 
                : 'bg-[#003366] text-white'
              : isLight 
                ? 'text-white/70 hover:text-white' 
                : 'text-black/50 hover:text-black'
          }`}
          data-testid="lang-switch-en"
          aria-label="English"
        >
          EN
        </button>
      </div>
    </div>
  );
};

export default LanguageSwitcher;
